module.exports = __webpack_public_path__ + "img/1482669176.66c5a8e3.jpg";